/* Redux Store */

import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './_reducers';

// export const store = createStore(
//   rootReducer(history),
//   compose(
//     applyMiddleware(
//       routerMiddleware(history),
//       thunkMiddleware
//     )
//   )
// );

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  rootReducer(),
  composeEnhancers(
    applyMiddleware(thunkMiddleware),
)
);